/**
 * boc头部操作组件
 * 
 */

import React, { Component } from 'react';
import styles from './IsrvHeaderOption.less';
import cx from 'classnames';
import CubeI8N from 'utils/cubeI8N';
class IsrvHeaderOption extends Component {
  constructor(props) {
    super(props)
  }
  
  componentWillMount() {
    // 多语言实例化
    this.CubeI8N = new CubeI8N();
  }

  render() {
    // 热线状态图标及颜色
    let iconList = [
      {},
      {icon: 'iconlaidian', color: '#57e087'},
      {icon: 'iconlikaiim', color: '#333'},
      {icon: 'iconxiumian', color: '#f5b800'},
      {icon: 'iconmangluim', color: '#fa944a'},
    ]

    // 在线状态图标及颜色
    let iconList2 = [
      {},
      {icon: 'iconzaixianfuwu2mian', color: '#57e087'},
      {},
      {icon: 'iconlikaiim', color: '#333'},
      {icon: 'iconxiumian', color: '#f5b800'},
      {icon: 'iconmangluim', color: '#fa944a'},
    ]

    return (
      <div className={styles.IsrvHeaderOption}>
        {/* 消息未读书为0时不显示 */}
        {this.props.messageNum != '0' && <div className={styles.box}>
          <span className={cx(styles.num, styles.marginRight)}>{this.props.value.messageNum}</span>
          <span>{this.CubeI8N.getString('header.newMessage', '新消息')}</span>
        </div>}
        <div className={styles.box} onClick={()=>this.props.onClick('hotLine')}>
          <span className={cx(styles.marginRight)}>{this.CubeI8N.getString('header.hotlineSupport', '热线服务')}</span>
          <i 
            className={cx('iconfont', iconList[this.props.value.hotLineStatus] ? iconList[this.props.value.hotLineStatus].icon : '')}
            style={iconList[this.props.value.hotLineStatus] ? {color: iconList[this.props.value.hotLineStatus].color} : {}}
          >            
          </i>
        </div>
        <div className={styles.box} onClick={()=>this.props.onClick('onLine')}>
          <span className={cx(styles.marginRight)}>{this.CubeI8N.getString('header.onlineSupport', '在线服务')}</span>
          <i 
            className={cx('iconfont', iconList2[this.props.value.onLineStatus] ? iconList2[this.props.value.onLineStatus].icon : '')}
            style={iconList2[this.props.value.onLineStatus] ? {color: iconList2[this.props.value.onLineStatus].color} : {}}
          >            
          </i>
        </div>
      </div>
    )
  }
}

IsrvHeaderOption.defaultProps = {
  value: {
    // 当前消息数
    messageNum: 0,
    // 当前热线服务状态
    hotLineStatus: '4',
    // 当前在线服务状态
    onLineStatus: '5',
  },
  // 点击事件
  onClick: (state) => {console.log(`你点击了${state}`)}
};

export default IsrvHeaderOption;


// WEBPACK FOOTER //
// ./src/widget/HeaderBar/ChildHeader/IsrvHeaderOption/IsrvHeaderOption.js